module.exports = "img/photo26.02af8f.jpg";